export function shouldWaitForMobileAuth({ isInitializing, isReconnecting, isProcessingAuth, backendAuthStatus, whitelistStatus, }) {
    return (isInitializing ||
        isReconnecting ||
        isProcessingAuth ||
        backendAuthStatus === "checking" ||
        backendAuthStatus === "unavailable" ||
        whitelistStatus === "checking");
}
